import {Text} from '@/components/ui/text/Text'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {useTranslation} from '@/translations/i18n'
import {formatDate} from '@/dayjs'
import {useFormContext, useWatch} from 'react-hook-form'
import {useGetAgendaEventsCount} from '../../queries/useGetAgendaEventsCount'
import {AddConsultantAbsenceFormValidationSchema} from '../../formSchemas'

export const ScheduledConsultantEventCount = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AddConsultantAbsenceFormValidationSchema>()
    const consultant = useWatch({control, name: 'consultant'})
    const startDateWatch = useWatch({control, name: 'startDate'})
    const endDateWatch = useWatch({control, name: 'endDate'})

    const {data: eventsCount, isLoading: isEventsCountLoading} = useGetAgendaEventsCount(
        {
            therapists: consultant ? [consultant?.id] : [],
            startDate: formatDate(startDateWatch),
            endDate: formatDate(endDateWatch),
            patients: []
        },
        {enabled: !!consultant && !!startDateWatch && !!endDateWatch}
    )

    return (
        <DetailsField fullWidth>
            <Text palette="neutral" shade="500" size="textSm">
                {t('agenda:scheduled_events')}
            </Text>
            {isEventsCountLoading ? (
                <Skeleton width={50} height={20} />
            ) : eventsCount?.numberOfEvents ? (
                <Text palette="neutral" shade="950" size="textSm" weight="500">
                    {eventsCount.numberOfEvents}
                </Text>
            ) : (
                <Text palette="neutral" shade="500" size="textSm">
                    -
                </Text>
            )}
        </DetailsField>
    )
}
